import t from "@/lang/lang";
import {
  DocumentPageNavigation,
  DocumentPageNavigationLink,
} from "@/shared/bsm/core/document/components/ui/document-page";

export function AssessmentSectionNavigation() {
  return (
    <DocumentPageNavigation>
      <DocumentPageNavigationLink end to=".">
        {t("Bestandsaufnahme")}
      </DocumentPageNavigationLink>
      <DocumentPageNavigationLink to="additional-info">
        {t("Zusätzliche Informationen")}
      </DocumentPageNavigationLink>
      <DocumentPageNavigationLink to="overview">
        {t("Übersicht")}
      </DocumentPageNavigationLink>
    </DocumentPageNavigation>
  );
}
